<template>
  <Modal v-model="logisticsFeeReimbursementModal" :title="$t('key1004270')" width="650" :transfer="false"
    :mask-closable="false" @on-visible-change="logisticsFeeReimbursementChange">
    <Form ref="logisticsFeeReimbursementForm" :model="logisticsFeeReimbursementForm" :rules="ruleValidate"
      :label-width="90" @submit.native.prevent>
      <Row style="width: 80%;">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item class="radio_styles" :label="$t('key1004271')" prop="supplementType">
            <RadioGroup v-model="logisticsFeeReimbursementForm.supplementType">
              <Radio :label="11">{{ $t('key1003951') }}</Radio>
              <Radio :label="12">{{ $t('key1003952') }}</Radio>
              <Radio :label="13">{{ $t('key1003953') }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1004272')" prop="supplementaryFees">
            <div class="flex align-items-center">
              <InputNumber style="width: 200px" :min="0" :max="99999999" :placeholder="$t('key1004273')"
                :formatter="(value) => formatterNumber(value, 2)" v-model.trim="logisticsFeeReimbursementForm.supplementaryFees">
              </InputNumber>
              <span class="ml6">{{ currencyState }}</span>
            </div>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="logisticsFeeReimbursementModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="logisticsFeeReimbursementBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {formatterNumber, isValueEmpty} from "@/utils/common";

export default {
  name: 'logisticsFeeReimbursementModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      logisticsFeeReimbursementModal: false,
      logisticsFeeReimbursementForm: {
        supplementType: 11,
        supplementaryFees: null
      },
      ruleValidate: {
        supplementaryFees: [
          {
            required: true,
            validator: (_, v, cb) =>
              isValueEmpty(v) ? cb(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004268')))
                : Number(v) <= 0 ? cb(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004269'))) : cb(),
            trigger: 'change'
          }
        ]
      },
      ymsPackageId: null
    };
  },
  methods: {
    // 初始化数据
    initLogisticsFeeReimbursementData(ymsPackageId) {
      this.ymsPackageId = ymsPackageId;
      this.logisticsFeeReimbursementModal = true;
    },
    formatterNumber,
    // 确定
    logisticsFeeReimbursementBtn() {
      this.$refs['logisticsFeeReimbursementForm'].validate(valid => {
        if (valid) {
          let query = {
            amount: this.logisticsFeeReimbursementForm.supplementaryFees,
            currency: this.currencyState,
            type: this.logisticsFeeReimbursementForm.supplementType,
            ymsPackageId: this.ymsPackageId
          };
          this.axios.post(api.post_ymsPackageInfo_addLogisticPrice, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
              this.$emit('updateData', true);
              this.logisticsFeeReimbursementModal = false;
            }
          });
        }
      });
    },
    // 监听弹窗
    logisticsFeeReimbursementChange(value) {
      if (!value) {
        this.$refs['logisticsFeeReimbursementForm'].resetFields();
      }
    }
  }
};
</script>

<style lang="less">

</style>
